// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2Ob0I","requiredAsterisk":"Info_requiredAsterisk__204JD"};